import { useSelector } from '@shared/store';

const DESKTOP_VIEWPORT_WIDTH_THRESHOLD = 840;

export function useIsDesktop() {
  const width = useSelector(state => state.appState.viewportWidth);
  return width >= DESKTOP_VIEWPORT_WIDTH_THRESHOLD;
}

export function useIsMobile() {
  const width = useSelector(state => state.appState.viewportWidth);
  return width < DESKTOP_VIEWPORT_WIDTH_THRESHOLD;
}
